const holidays = [
    "2025-05-01",
    "2025-08-09",
    "2025-08-15",
    "2025-08-27",
    "2025-09-06",
    "2025-10-02",
    "2025-10-21",
    "2025-10-22",
    "2025-10-23",
    "2025-12-25",
];


module.exports = { holidays }